import { render, staticRenderFns } from "./total.vue?vue&type=template&id=2d33133a&scoped=true"
import script from "./total.vue?vue&type=script&lang=js"
export * from "./total.vue?vue&type=script&lang=js"
import style0 from "./total.vue?vue&type=style&index=0&id=2d33133a&prod&lang=scss"
import style1 from "./total.vue?vue&type=style&index=1&id=2d33133a&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2d33133a",
  null
  
)

export default component.exports